export const VALIDATION_TYPE = {
    ERROR: 'error',
    WARNING: 'warning',
};
